import React, { useEffect, useState } from "react";
import * as BosWebGuiServices from "data/BosWebServices/BosWebGuiServices";
import * as BosIdentityServices from "data/BosWebServices/BosIdentityServices";
import SolutionGroups from "./GroupView/Groups";
import SolutionTiles from "./TileView/Tiles";
import ContentLoadingBOS from "components/ContentLoadingBos";
import ErrorMessageView from "../ErrorMessageView";
import { Link } from 'react-router-dom';
import { openInNewCleanWindow } from "../../logic/Utils";
import { getTranslation as translate } from "logic/LocaleManager";

// Externals
//import cn from "classnames";

// DevExteme Components
import { Button } from "devextreme-react";

// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as solutionsCacheActions from "redux/actions/solutionsCacheActions";

function Launchpad(props) {
  const { configDataAuthToken, availableSolutionsCache, currentDataSegment, currentUILanguageCode } = props;

  const GROUP_VIEW = "SOLUTIONVIEW";
  const TILE_VIEW = "APPVIEW";
  const tileViewText = translate("launchpad.tileViewText", "(Simple view -> show grouped view)");
  const groupViewText = translate("launchpad.groupViewText", "(Grouped view -> show simple view)");
  //const openHint = translate("launchpad.openHint", "Click to open or hold CTRL and click to open in new tab/window");

  const isTileView = (view) => view === TILE_VIEW;

  const currentDataSegmentId = currentDataSegment ? currentDataSegment.id : null;

  const [isLoading, setIsLoading] = useState(false);
  const [view, setView] = useState(TILE_VIEW);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (availableSolutionsCache.length > 0) {
      console.log("Found cached available Solutions", availableSolutionsCache);
    }
    else {
      fetchData();
    }
  }, [configDataAuthToken, availableSolutionsCache.length]);

  useEffect(() => {
    fetchData();
  }, [currentUILanguageCode]);

  async function fetchData() {
    try {
      setIsLoading(true);
      let useSessionId = await BosWebGuiServices.fetchStartSession(configDataAuthToken);
      console.log("StartSession result: ", useSessionId);
      let result = await BosWebGuiServices.fetchGetAvailableSolutions(configDataAuthToken, useSessionId);
      console.log("Fetching available Solutions result: ", result);
      props.solutionsCacheActions.setSolutionsCache(result || []);
      console.log("Session cleanup", useSessionId);
      await BosWebGuiServices.fetchCloseSession(configDataAuthToken, useSessionId);
      setIsLoading(false);
      setError();
    } catch (error) {
      console.error("Fetching available Solutions error: ", error);
      props.solutionsCacheActions.clearSolutionsCache();
      setIsLoading(false);
      setError(true);
    }
  }

  async function handleDataClicked(args, solution, data) {
    let openExternal = true; // args.event.ctrlKey;
    let targetUrl = "/Workspace/" + solution.technicalName + "/" + data.technicalName;
    if (openExternal) {
      try {
        //external
        let result = await BosIdentityServices.fetchRequestOneTimeToken(configDataAuthToken, targetUrl);
        console.log("Fetching OneTimeToken result: ", result);
        let url = "tokenLogin/" + result.oneTimeToken;
        openInNewCleanWindow(url);
      } catch (error) {
        console.error("Fetching OneTimeToken error: ", error);
        setError(true);
      }
    }
    else {
      //internal
      let url = targetUrl;
      props.history.push(url);
    }
  }

  function refreshButtonClicked(e) {
    fetchData();
  }

  function switchViewLinkClicked(e) {
    e.preventDefault();
    setView(prev => isTileView(prev) ? GROUP_VIEW : TILE_VIEW);
  }

  return (
    <div>
      <div>
        <div className={"ui-default-headline"}>
          {translate("launchpad.title", "Solutions")}
          <Button
            icon="refresh"
            stylingMode="text"
            hint={translate("launchpad.refresh", "Refresh")}
            onClick={(e) => refreshButtonClicked(e)}
          />
        </div>
        <Link
          to=""
          onClick={(e) => switchViewLinkClicked(e)}
        >
          {isTileView(view) ? tileViewText : groupViewText}
        </Link>
      </div>
      {isLoading
        ? <ContentLoadingBOS />
        : error
          ? <ErrorMessageView />
          : (
            isTileView(view)
              ? <SolutionTiles solutions={availableSolutionsCache} currentDataSegmentId={currentDataSegmentId} onDataClick={handleDataClicked} />
              : <SolutionGroups solutions={availableSolutionsCache} currentDataSegmentId={currentDataSegmentId} onDataClick={handleDataClicked} />
          )
      }
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    availableSolutionsCache: state.solutionsCache.cachedAvailableSolutions,
    configDataAuthToken: state.dataSegments.configDataSegment.authToken,
    currentDataSegment: state.dataSegments.currentDataSegment,
    currentUILanguageCode: state.appState.uiLanguageIsoCode,
    currentDataViewLanguageCode: state.appState.dataViewLanguageIsoCode,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    solutionsCacheActions: bindActionCreators(solutionsCacheActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Launchpad);
